export default __webpack_public_path__ + "media/images/backgrounds/spinning-trees-9fd6db5a51081218e58a76ab13c9fc14.jpg";